import { type NormalizedRating, type RatingType } from "@src/appV2/redesign/Tiers/utils/types";

// eslint-disable-next-line consistent-return
export function calculateRating(
  ratingType: RatingType,
  successEvents: number,
  totalEvents: number
): NormalizedRating {
  // eslint-disable-next-line default-case
  switch (ratingType) {
    case "onTimeArrival":
    case "shiftCompletionWithoutCancel": {
      if (totalEvents === 0) {
        return {
          ratingType,
          rating: 100,
          display: "–%",
          ratingHasEvents: false,
        };
      }

      const rating = Math.floor((successEvents / totalEvents) * 100);

      return {
        ratingType,
        rating,
        display: `${rating}%`,
        ratingHasEvents: true,
      };
    }

    case "shiftCompletionWithoutLateCancel": {
      const rating = successEvents;

      return {
        ratingType,
        rating,
        display: `${rating}`,
        ratingHasEvents: totalEvents > 0,
      };
    }
  }
}
